<template>
  <div class="pages">
    <el-pagination v-if="total>0" background
                   layout="prev, pager, next"
                   :page-size="pageSize"
                   :page-count="pageCount"
                   :current-page.sync="currentPageIndex"
                   :total="total"
                   @current-change="OnCurrentChanged"
    >
    </el-pagination>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "pages",
  model: {
    event: "current-page-changed"
  },
  props: ["pageSize", "pageCount", "currentPage", "total"],
  data() {
    return {
      currentPageIndex: 1
    };

  },
  created() {
    this.currentPageIndex = this.currentPage;
  },

  watch:{
    currentPage(val){
      this.currentPageIndex = val;
    }
  },
  methods: {
    OnCurrentChanged() {
      this.$emit("current-page-changed", this.currentPageIndex);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
button, li {
  background-color: #ffffff;
}

.pages {
  position: relative;
  margin: 50px auto;
  text-align: center;

  .el-pagination.is-background {
    .el-pager {
      li {
        width: 0.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #ffffff;
      }
    }

    .btn-prev, .btn-next {
      width: 0.6rem;
      height: 0.6rem;
      line-height: 0.6rem;
      background-color: #ffffff;
    }
  }
}
.pages >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0060ff;
}
.pages >>> .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #0060ff;
}
.pages >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #fff;
}
</style>
<style>
  .el-pagination.is-background .el-pager li{
    width: 0.6rem;
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 0.08rem;
    min-width: auto;
  }
  .el-pagination.is-background .el-pager li.active{
    width: 0.63rem;
    height: 0.63rem;
    line-height: 0.63rem;
  }
  .el-pagination.is-background .btn-prev,.el-pagination.is-background .btn-next {
    width: 0.6rem;
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 0.08rem;
    min-width: auto;
  }
  .el-pagination.is-background .btn-next{
    color:#0060ff;
  }


  .fixconent .hostactivity .pages .el-pagination.is-background .el-pager li {
    width:35px;
    height: 35px;
    line-height: 35px;
  }
  .fixconent .hostactivity .pages .el-pagination.is-background .btn-prev,
  .fixconent .hostactivity .pages .el-pagination.is-background .btn-next{
    width:35px;
    height: 35px;
    line-height: 35px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages.vue